
import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row, Typography, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const { Title, Text } = Typography;

const EditCollaterals = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [collateralName, setcollateralName] = useState("");
  const [collateralDescription, setcollateralDescription] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [existingPdfUrl, setExistingPdfUrl] = useState("");

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  useEffect(() => {
    const fetchCollateral = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/collateral/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const { collateralName, collateralDescription, pdfUrl } = response.data;
        setcollateralName(collateralName);
        setcollateralDescription(collateralDescription);
        setExistingPdfUrl(pdfUrl);
      } catch (err) {
        message.error("Failed to fetch form data");
      }
    };

    fetchCollateral();
  }, [id, token]);

  const handleUpdate = async () => {
    if (!collateralName || !collateralDescription) {
      message.warning("All fields are required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("collateralName", collateralName);
      formData.append("collateralDescription", collateralDescription);
      if (pdfFile) {
        formData.append("pdfs", pdfFile);
      }

      await axios.put(`${process.env.REACT_APP_API_BASEURL}/collateral/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      message.success("Collateral updated successfully");
      navigate("/collaterals");
    } catch (err) {
      message.error("Failed to update collateral");
    }
  };

  return (
    <div className="p-4">
      <Card title="Edit Collateral">
        <Row gutter={16}>
          <Col span={12}>
            <Text strong>Collateral Name</Text>
            <Input
              value={collateralName}
              onChange={(e) => setcollateralName(e.target.value)}
              placeholder="Form name"
              style={{ marginBottom: 20 }}
            />
          </Col>
          <Col span={12}>
            <Text strong>Description</Text>
            <Input
              value={collateralDescription}
              onChange={(e) => setcollateralDescription(e.target.value)}
              placeholder="Description"
              style={{ marginBottom: 20 }}
            />
          </Col>
        </Row>

        {/* Show existing PDF */}
        {existingPdfUrl && (
          <div style={{ marginBottom: 20 }}>
            <Text>
              Existing PDF:{" "}
              <a href={existingPdfUrl} target="_blank" rel="noopener noreferrer">
                View PDF
              </a>
            </Text>
          </div>
        )}

        <div
          style={{
            border: "2px dashed #d9d9d9",
            padding: "40px",
            textAlign: "center",
            marginBottom: "20px",
            borderRadius: "8px",
            cursor: "pointer",
          }}
          onClick={() => document.getElementById("pdfUpload").click()}
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/1828/1828491.png"
            alt="Upload"
            style={{ width: "40px", marginBottom: "10px", opacity: 0.5 }}
          />
          <div style={{ fontWeight: 600, fontSize: "16px" }}>
            Drop file here to upload
          </div>
          <input
            id="pdfUpload"
            type="file"
            accept="application/pdf"
            onChange={(e) => setPdfFile(e.target.files[0])}
            style={{ display: "none" }}
          />
        </div>

        {/* Buttons */}
        <Row gutter={16}>
          <Col>
            <Button type="primary" icon={<EditOutlined />} style={{ backgroundColor: PRIMARY_RED }} onClick={handleUpdate}>
              Edit Collateral
            </Button>
          </Col>
          <Col>
            <Button
              type="link"
              style={{ color: PRIMARY_RED }}
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/collaterals")}
            >
              Back
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default EditCollaterals;

